class ModelUnitAdd {
  constructor(data = {}) {
    this.idUnidadModelo = data.idUnidadModelo || 0;
    this.idMarca = data.idMarca || 0;
    this.descripcion = data.descripcion || "";
    this.usuarioRegistro = data.usuarioRegistro || 0;
    this.marca = data.marca || "";
    this.fechaRegistro = data.fechaRegistro || "";
    this.estatus = data.estatus || true;
  }
}

class ModelUnitEdit {
  constructor(data = {}) {
    this.idUnidadModelo = data.idUnidadModelo || 0;
    this.idMarca = data.idMarca || 0;
    this.descripcion = data.descripcion || "";
    this.usuarioRegistro = data.usuarioRegistro || 0;
    this.marca = data.marca || "";
    this.fechaRegistro = data.fechaRegistro || "";
    this.estatus = data.estatus || true;
  }
}

export { ModelUnitEdit, ModelUnitAdd };
